import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalService } from '../../modal/modal.service';
import { NotificationService } from '../../notification/notification.service';
import { ChatService } from '@features/chat/chat.service';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';

@Component({
  selector: 'app-start-trivia-modal',
  templateUrl: './start-trivia-modal.component.html',
  styleUrls: ['./start-trivia-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalBoxComponent, FormsModule, ReactiveFormsModule],
})
export class StartTriviaModalComponent {
  triviaForm = new FormGroup({
    amount: new FormControl(undefined, [Validators.required, Validators.min(1)]),
    triviaQuestion: new FormControl('', [Validators.required, Validators.minLength(3)]),
    triviaAnswer: new FormControl('', [Validators.required, Validators.minLength(2)]),
    triviaAnswer2: new FormControl('', [Validators.required, Validators.minLength(2)]),
    triviaAnswer3: new FormControl('', [Validators.required, Validators.minLength(2)]),
  });

  constructor(private chatService: ChatService, private notificationsService: NotificationService, private modalService: ModalService) {}

  async startTrivia() {
    const errors = [];
    if (this.triviaForm.controls['triviaQuestion'].errors) {
      errors.push('Question must be at least 3 characters long');
    }

    if (this.triviaForm.controls['amount'].errors) {
      errors.push('Amount must be at least 1');
    }

    const answers = [this.triviaForm.value.triviaAnswer, this.triviaForm.value.triviaAnswer2, this.triviaForm.value.triviaAnswer3].filter((item) => item !== '');

    if (this.triviaForm.controls['triviaAnswer'].errors || this.triviaForm.controls['triviaAnswer2'].errors || this.triviaForm.controls['triviaAnswer3'].errors) {
      errors.push('You must have at answers');
    }

    if (this.triviaForm.invalid) {
      this.notificationsService.error(errors.join('. '), 'ERROR');

      return;
    }

    await this.chatService.startTrivia(this.triviaForm.value.triviaQuestion, answers, this.triviaForm.value.amount);
    this.modalService.close();
  }
}
